import { create } from 'zustand'

import type { MyLine } from '#/shared/api/generated/communication/models'

interface ActiveLineState {
  /** The user's explicit pick; null until they choose. */
  selectedId: string | null
  select: (id: string) => void
}

/**
 * The single active outbound line shared across the whole app. The phone-panel
 * header switcher and the telephony connection panel both read and write this
 * one pick, so the line you choose in either place is the line every send and
 * call goes out from — change it in one and the other reflects it.
 */
export const useActiveLineStore = create<ActiveLineState>((set) => ({
  selectedId: null,
  select: (id) => set({ selectedId: id }),
}))

/** Resolve the active line: explicit pick → default line → first available. */
export function resolveActiveLine(
  lines: MyLine[],
  selectedId: string | null,
): MyLine | null {
  if (lines.length === 0) return null
  return (
    lines.find((line) => line.id === selectedId) ??
    lines.find((line) => line.is_default) ??
    lines[0]
  )
}
